import { State, Action, StateContext, Selector, Store, Select } from '@ngxs/store';
import { patch } from '@ngxs/store/operators';
import { Injectable } from '@angular/core';
import * as UserTypesActions from './user-types.action';
import { UserTypesService } from './user-types.service';
import { BannerService } from '../../shared/services/banner.service';
import { HelperService } from '../helper/helper.service';
import { AuthenticationService } from '../../shared/services/authentication.service';
import { UserTypeListModel } from '../../models/user-types/user-types';


export interface UserTypesStateModel {
  UserTypesList: UserTypeListModel;
}

@State<UserTypesStateModel>({
  name: 'userTypes',
  defaults: {
    UserTypesList: null
  }
})

@Injectable()

export class UserTypesState {

  constructor(
    private helperService: HelperService,
    private userTypesService: UserTypesService,
    private bannerService: BannerService,
    private authService: AuthenticationService
  ) { }


  @Selector()
  static UserTypesList(state: UserTypesStateModel) {
    return state.UserTypesList;
  }


  @Action(UserTypesActions.GetList)
  GetList(
    context: StateContext<UserTypesStateModel>,
    action: UserTypesActions.GetList
  ) {

    const errorMessage = 'Błąd pobierania listy typów użytkowników.';

    context.setState(
      patch({
        UserTypesList: null
      })
    );

    this.userTypesService.getList().subscribe((ret) => {
      if (ret.Success) {
        context.setState(
          patch({
            UserTypesList: ret
          })
        );

        return ret;

      } else {
        this.bannerService.error(ret.Message, errorMessage);
      }
    },
      (error) => {
        this.helperService.SaveException('UserTypesActions.GetList', error);

        this.bannerService.error(errorMessage);
      });
  }
}




